import React from 'react'
import PropTypes from 'prop-types'
import { cn } from 'shared/util/cn'

function Label({ children, className = '', htmlFor }) {
  return (
    <label htmlFor={htmlFor} className={cn('mb-2 block text-sm font-medium text-ink', className)}>
      {children}
    </label>
  )
}

Label.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  htmlFor: PropTypes.string
}

export default Label
